module.exports = __webpack_public_path__ + "static/media/downline.9c86028f.svg";